import { eventBus } from '../../core/events';
import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

export function registerScreenSteps(registry: StepRegistry): void {
  registry.register('show-screen', async (step) => {
    const { image, component, device, title, subtitle, role, url } = step.params;

    eventBus.emit('screen:show', { image, component, device, title, subtitle, role, url, duration: step.duration });

    await wait(step.duration);

    eventBus.emit('screen:hide', {});
    await wait(500);
  });
}
